import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { TreatmentList } from './TreatmentList';
import { treatments } from '../data/treatments';
import type { Complaint } from '../types/care';
interface ComplaintPanelProps {
  complaint: Complaint;
  onBack: () => void;
}
export function ComplaintPanel({
  complaint,
  onBack
}: ComplaintPanelProps) {
  const related = complaint.treatmentSlugs.map(slug => treatments.find(t => t.slug === slug)).filter((t): t is NonNullable<typeof t> => Boolean(t));
  return <div data-id="element-73" data-mp="3bpwr2sswnvgf">
      <button type="button" onClick={onBack} className="inline-flex items-center gap-2 text-sm font-medium text-muted transition-colors duration-150 hover:text-primary" data-id="element-74" data-mp="3bp57kgcl1o6i">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-75" data-mp="1hc5mw8tci3sd" />
        Alle pijnklachten
      </button>

      <div className="mt-5 overflow-hidden rounded-2xl" data-id="element-76" data-mp="1m9xc2v2lvbsv">
        <img src={complaint.image} alt="" className="aspect-[16/9] w-full object-cover sm:aspect-[21/8]" data-id="element-77" data-mp="1mcjrthzngxm6" />
      </div>
      <h3 className="mt-6 font-display text-2xl font-semibold text-ink sm:text-[28px]" data-id="element-78" data-mp="3fm9r5k89tx3e">{complaint.title}</h3>
      <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-muted" data-id="element-79" data-mp="3bjwkmtlp9v5k">
        {complaint.description.map(p => <p key={p} data-id="element-80" data-mp="36medn8r8tq07">{p}</p>)}
      </div>

      <div className="mt-8 flex items-end justify-between gap-4" data-id="element-81" data-mp="767w79265891">
        <h4 className="font-display text-lg font-semibold text-ink" data-id="element-82" data-mp="75og7xw2wtxn">Behandelingen</h4>
        <Link to={`/pijnbehandelingen/${complaint.slug}`} className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary hover:text-primary-dark" data-id="element-83" data-mp="35xpfu6jydt4">
          Open als pagina
          <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-84" data-mp="3pe734t73st36" />
        </Link>
      </div>
      <p className="mt-1 text-sm text-muted" data-id="element-85" data-mp="2ito393yznes1">Klik op een behandeling voor uitleg en de patiëntenfolder.</p>
      <div className="mt-4" data-id="element-86" data-mp="2dz0kllqo1eld">
        <TreatmentList key={complaint.slug} treatments={related} data-id="element-87" data-mp="2fdbh5eqyw0d9" />
      </div>
    </div>;
}